import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomRule } from '../models/filter-models';
import { Comparator, YesNoAny } from "../models/enums";
import { FormsModule } from '@angular/forms';
import { ItemDataService } from '../services/item-data.service';
import { AutocompleteComponent } from '../common/autocomplete/autocomplete.component';
import { SelectComponent, SelectOptionComponent } from '../common/select/select.component';
import { BaseComponent } from '../common/base.component';
import { socketGroupKeyDown } from '../common/helper';

@Component({
  selector: '[app-advanced-conditions-filter]',
  imports: [FormsModule, AutocompleteComponent, SelectComponent, SelectOptionComponent],
  templateUrl: './advanced-conditions-filter.component.html',
  styleUrl: './advanced-conditions-filter.component.scss'
})
export class AdvancedConditionsFilterComponent extends BaseComponent {
  @Input({ required: true }) rule!: CustomRule; // TODO: advancedConditions is sometimes null. Try to find out where that comes from.
  @Output('updateFilter') updateFilterEmitter = new EventEmitter<void>();

  classesWithDefenceTypes: string[] = [];
  cantHaveQuality: string[] = [];
  cantHaveSockets: string[] = [];
  canHaveUnidentifiedTier: string[] = [];
  canHaveInfluence: string[] = [];
  canBeIdentified: string[] = [];

  transfiguredGems: string[] = [];

  Comparator = Comparator;
  YesNoAny = YesNoAny;

  influences: { name: string, image: string }[] = [];
  clusterJewelPassiveNodes: { name: string }[] = [];

  socketGroupKeyDown = socketGroupKeyDown;

  constructor(private itemDataService: ItemDataService) {
    super();
    this.classesWithDefenceTypes = this.itemDataService.getClassesWithDefenceTypes();
    this.cantHaveQuality = this.itemDataService.getCantHaveQuality();
    this.cantHaveSockets = this.itemDataService.getCantHaveSockets();
    this.canHaveUnidentifiedTier = this.itemDataService.getAllWeaponTypes(true).concat(this.itemDataService.getAllArmourTypes()).concat(['Belts', 'Amulets', 'Rings', 'Life Flasks', 'Mana Flasks', 'Charms', 'Jewels']);
    this.canHaveInfluence = this.itemDataService.getAllArmourTypes().concat(this.itemDataService.getAllWeaponTypes()).concat(['Belts', 'Amulets', 'Rings']);
    this.influences = this.itemDataService.getInfluences();
    this.transfiguredGems = this.itemDataService.getTransfiguredGems();
    this.clusterJewelPassiveNodes = this.itemDataService.getClusterJewelPassiveNodes().map(e => ({ name: e }));
    this.canBeIdentified = this.itemDataService.getCanBeIdentified();
  }

  updateFilter() {
    this.updateFilterEmitter.emit();
  }

  toggleEnchantment() {
    if (this.rule.advancedConditions!.anyEnchantment) {
      this.rule.advancedConditions!.anyEnchantment = undefined;
    } else {
      this.rule.advancedConditions!.anyEnchantment = true;
    }
    this.updateFilter();
  }

  toggleZanaMemory() {
    if (this.rule.advancedConditions!.zanaMemory) {
      this.rule.advancedConditions!.zanaMemory = undefined;
    } else {
      this.rule.advancedConditions!.zanaMemory = true;
    }
    this.updateFilter();
  }

  toggleInfluenced() {
    if (this.rule.advancedConditions!.hasInfluence) {
      this.rule.advancedConditions!.hasInfluence = undefined;
    } else {
      this.rule.advancedConditions!.hasInfluence = true;
    }
    this.updateFilter();
  }

  toggleBlightedMap() {
    if (this.rule.advancedConditions!.blightedMap) {
      this.rule.advancedConditions!.blightedMap = undefined;
    } else {
      this.rule.advancedConditions!.blightedMap = true;
    }
    this.updateFilter();
  }

  toggleBlightRavagedMap() {
    if (this.rule.advancedConditions!.blightRavagedMap) {
      this.rule.advancedConditions!.blightRavagedMap = undefined;
    } else {
      this.rule.advancedConditions!.blightRavagedMap = true;
    }
    this.updateFilter();
  }

  toggleEightModMap() {
    if (this.rule.advancedConditions!.eightModMap) {
      this.rule.advancedConditions!.eightModMap = undefined;
    } else {
      this.rule.advancedConditions!.eightModMap = true;
    }
    this.updateFilter();
  }

  toggleClusterJewelEnchantments() {
    if (this.rule.advancedConditions!.clusterJewelPassiveNodes === undefined) {
      this.rule.advancedConditions!.clusterJewelPassiveNodes = [this.clusterJewelPassiveNodes[0].name];
    } else {
      this.rule.advancedConditions!.clusterJewelPassiveNodes = undefined;
    }
    this.updateFilter();
  }

  clusterJewelPassiveNodesChange(event: string[]) {
    if (event.length === 0) {
      this.rule.advancedConditions!.clusterJewelPassiveNodes = undefined;
    } else {
      this.rule.advancedConditions!.clusterJewelPassiveNodes = event;
    }
    this.updateFilter();
  }
}
